import { Icon } from "@fluentui/react";
import { Utils } from "../../../../common/views/Utils";
import { OrderModel } from "../../../models/OrderModel";

type OrderDetailHeaderProps = {
    order: OrderModel | null | undefined;
    showCustomer: boolean;
    onClose: () => void;
}

export default function OrderDetailHeaderView({ order, showCustomer, onClose }: OrderDetailHeaderProps) {
    const width6 = Utils.getColumnWidth(6);

    return <div className="popup-header">
        <div className="ms-Grid ml--10 mr--10">
            <div className="ms-Grid-row bold">
                <div className={width6}>
                    Order Details: {order?.id}
                </div>
                <div className={width6 + " right"}>
                    {showCustomer && <span className="bold pr-10">{order?.customer} - {order?.id}</span>}
                    <Icon
                        iconName="ChromeClose"
                        className="pointer"
                        onClick={onClose}
                    />
                </div>
            </div>
        </div>
    </div>;
}